import type { ReactNode, SVGAttributes } from 'react'

const paths = {
  'plus-circle': <><circle cx="12" cy="12" r="9"/><path d="M12 8.5v7M8.5 12h7"/></>,
  megaphone: <><path d="M4 10v4a1 1 0 0 0 1 1h2l7 4V5L7 9H5a1 1 0 0 0-1 1Z"/><path d="M17.5 9a4 4 0 0 1 0 6"/></>,
  'bar-chart': <path d="M5 20V11M12 20V4M19 20v-6"/>,
  gear: <><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 9 19.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.6 9a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1Z"/></>,
  'help-circle': <><circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.4 2.4 0 1 1 3.2 2.3c-.6.2-.8.7-.8 1.3v.4"/><path d="M12 17h.01"/></>,
  link: <><path d="M10 13a4 4 0 0 0 5.7.4l2.6-2.6a4 4 0 0 0-5.7-5.7l-1.5 1.5"/><path d="M14 11a4 4 0 0 0-5.7-.4L5.7 13.2a4 4 0 0 0 5.7 5.7l1.5-1.5"/></>,
  pencil: <><path d="M4 20h4L19 9a2.8 2.8 0 0 0-4-4L4 16v4Z"/><path d="M14.5 6.5 17.5 9.5"/></>,
  cart: <><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3.5h2.2l2.3 11h11.4l2.1-8H6"/></>,
  eye: <><path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z"/><circle cx="12" cy="12" r="3"/></>,
  user: <><circle cx="12" cy="8" r="3.4"/><path d="M4.5 20a7.5 7.5 0 0 1 15 0"/></>,
  'user-cog': <><circle cx="10" cy="8" r="3.4"/><path d="M3.5 20a6.6 6.6 0 0 1 9.2-6"/><circle cx="17.5" cy="16.5" r="2.6"/><path d="M17.5 12.9v1.1M17.5 19v1.1M21 14.6l-1 .6M15 17.8l-1 .6M21 18.4l-1-.6M15 15.2l-1-.6"/></>,
  check: <path d="M4.5 12.5 9.5 17.5 19.5 6.5"/>,
  'check-circle': <><circle cx="12" cy="12" r="9"/><path d="M8 12.2 10.9 15 16 9.4"/></>,
  'chevron-right': <path d="M9.5 5.5 16 12l-6.5 6.5"/>,
  'chevron-down': <path d="M5.5 9 12 15.5 18.5 9"/>,
  search: <><circle cx="11" cy="11" r="6.5"/><path d="M16 16l4.5 4.5"/></>,
  info: <><circle cx="12" cy="12" r="9"/><path d="M12 11v5.5"/><path d="M12 7.8h.01"/></>,
  alert: <><path d="M12 3.5 22 20H2L12 3.5Z"/><path d="M12 10v4M12 17h.01"/></>,
  dollar: <><path d="M12 3v18"/><path d="M16.5 7.5A3.5 3.5 0 0 0 13 5h-2a3 3 0 0 0 0 6h2a3 3 0 0 1 0 6h-2a3.5 3.5 0 0 1-3.5-2.5"/></>,
  play: <><circle cx="12" cy="12" r="9"/><path d="M10 8.5 16 12l-6 3.5v-7Z"/></>,
  clipboard: <><rect x="5" y="4.5" width="14" height="16" rx="2"/><path d="M9 4.5V3.6a1.6 1.6 0 0 1 1.6-1.6h2.8A1.6 1.6 0 0 1 15 3.6v.9"/><path d="M9 12.6l2 2 4-4"/></>,
  trend: <><path d="M3 17 9.5 10.5 13.5 14.5 21 7"/><path d="M15.5 7H21v5.5"/></>,
  target: <><circle cx="12" cy="12" r="8.5"/><circle cx="12" cy="12" r="4.5"/><circle cx="12" cy="12" r="1"/></>,
  calendar: <><rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 10h17M8 3.2v3.4M16 3.2v3.4"/></>,
  compare: <><rect x="3.5" y="3.5" width="17" height="17" rx="4"/><path d="M8 12.2 10.9 15 16 9.4"/></>,
  bag: <><path d="M5 8h14l-1 12.5H6L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></>,
  users: <><circle cx="9" cy="8" r="3.2"/><path d="M2.8 20a6.2 6.2 0 0 1 12.4 0"/><path d="M16.4 5.2a3.2 3.2 0 0 1 0 5.6M17.6 20a6.2 6.2 0 0 0-2.2-4.7"/></>,
  message: <path d="M20.5 12.5a7.5 7.5 0 0 1-10.7 6.8L4 20.5l1.3-5.4A7.5 7.5 0 1 1 20.5 12.5Z"/>,
  upload: <><path d="M12 16.5V4.5M7.5 9 12 4.5 16.5 9"/><path d="M4.5 15v3.5a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V15"/></>,
  sparkle: <path d="M12 3.5 13.9 9 19.5 10.9 13.9 12.8 12 18.4 10.1 12.8 4.5 10.9 10.1 9 12 3.5Z"/>,
  inbox: <><path d="M3.5 13.5h4l1.6 3h5.8l1.6-3h4"/><path d="M5.6 4.9 3.5 13.5v4a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-4L18.4 4.9a2 2 0 0 0-1.9-1.4h-9a2 2 0 0 0-1.9 1.4Z"/></>,
  x: <path d="M6 6l12 12M18 6 6 18"/>,
  home: <><path d="M4 10.4 12 4l8 6.4V19a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19v-8.6Z"/><path d="M9.6 20.5v-6.2h4.8v6.2"/></>,
  vault: <><rect x="3.5" y="4.5" width="17" height="15" rx="2.5"/><path d="M3.5 15.6 8 11.1l3.4 3.4L15 10.9l5.5 5.5"/><circle cx="8.8" cy="9" r="1.35"/></>,
  activity: <path d="M3 12h3.5l2.5-6 4 12 2.5-6H21"/>,
  sliders: <><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/></>,
  clock: <><circle cx="12" cy="12" r="9"/><path d="M12 7.5V12l3 2"/></>,
  file: <><path d="M6 3.5h8l4 4v13H6v-17Z"/><path d="M14 3.5v4h4M9 12h6M9 15.5h6"/></>,
  download: <><path d="M12 4v11M7.5 10.5 12 15l4.5-4.5"/><path d="M4.5 16v2.5a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V16"/></>,
  send: <><path d="M20.5 3.5 10.5 13.5"/><path d="M20.5 3.5 14 20.5l-3.5-7-7-3.5 17-6.5Z"/></>,
  globe: <><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3a14 14 0 0 1 0 18M12 3a14 14 0 0 0 0 18"/></>,
  lock: <><rect x="5" y="10.5" width="14" height="10" rx="2"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/></>,
  shield: <><path d="M12 3.5 19.5 6.5v5.2c0 4.3-3.1 7.6-7.5 8.8-4.4-1.2-7.5-4.5-7.5-8.8V6.5L12 3.5Z"/><path d="M9 12l2 2 4-4"/></>,
} satisfies Record<string, ReactNode>

export type IconName = keyof typeof paths

export interface IconProps extends Omit<SVGAttributes<SVGSVGElement>, 'name'> {
  name: IconName
  size?: number
  strokeWidth?: number
}

export function Icon({ name, size = 20, strokeWidth = 1.7, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {paths[name]}
    </svg>
  )
}
